var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmile1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.555,
    height: 84.555,
    viewBox: "0 0 84.555 84.555",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1723",
    "data-name": "Group 1723",
    transform: "translate(1591.186 -995.223)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 42.277,
    cy: 42.277,
    r: 42.277,
    transform: "translate(-1591.186 995.223)",
    fill: "#ffd442"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M3666.9,1115.733s19.707,12.612,23.614,6.369",
    transform: "translate(-5242.389 -93.4)",
    fill: "none",
    stroke: "#594504",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 6.04,
    cy: 6.04,
    r: 6.04,
    transform: "translate(-1571.054 1027.434)",
    fill: "#594504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756-2",
    "data-name": "Path 1756",
    d: "M3690.513,1115.733s-19.708,12.612-23.615,6.369",
    transform: "translate(-5210.177 -93.4)",
    fill: "none",
    stroke: "#594504",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44-2",
    "data-name": "Ellipse 44",
    cx: 6.04,
    cy: 6.04,
    r: 6.04,
    transform: "translate(-1536.179 1027.434)",
    fill: "#594504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M3670.246,1131.337s11.891-18.551,28.965,0",
    transform: "translate(-5232.256 -71.128)",
    fill: "none",
    stroke: "#594504",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile1);
export default __webpack_public_path__ + "static/media/smile1.0b6126f371907a5918f781ac33b6e1d7.svg";
export { ForwardRef as ReactComponent };